import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import IntroSection from '../components/about/IntroSection';
import MissionVision from '../components/about/MissionVision';
import Timeline from '../components/about/Timeline';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <>
      <Header />
      <main>
        <IntroSection />
        <MissionVision />
        <Timeline />
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
